<small class="debug">{{me}}</small>
@if (filterMode) {
  <mat-form-field class="form-element">
    <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
    <input inputrestriction="basic1" matInput type="text" name="SearchDualList" class="form-control" [(ngModel)]="filter" autocomplete="off"/>
    <a matSuffix aria-label="Clear" (click)="clearFilterSelection()">
      <mat-icon>close</mat-icon>
    </a>
  </mat-form-field>
}
@if (createMode) {
  <div>
    <div style="padding: 5px 0;">
      <app-add-node (addedNode)="addNode($event)" [isTop]="true"></app-add-node>
      <button mat-button (click)="toggleExpandAll()">
        <mat-icon matTooltip="toggle expand all" >device_hub</mat-icon>
      </button>
      <!-- <button mat-button (click)="onClickUndoTree()" [disabled]="disableUndo">
      <mat-icon matTooltip="undo tree" >undo</mat-icon>
    </button>
    <button mat-button (click)="onClickRedoTree()" [disabled]="disableRedo">
      <mat-icon matTooltip="redo tree" >redo</mat-icon>
    </button> -->
    <!--        <app-video-link style="display: inline-block;" [iconButton]="true" videoLink="/help/category"></app-video-link>-->
  </div>
  <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="static-tree-wrapper mat-tree-position">
    <!-- Without Children -->
    <mat-tree-node *matTreeNodeDef="let node">
      <!--            <pre>{{node | json}}</pre>-->
      <li class="mat-tree-node" (click)="onNodeSelected(node)" [ngStyle]="{'color': clickSelection.isSelected(node) ? markTreeSelection : null}">
        <button mat-icon-button disabled></button>
        {{node.Name}}
        <div class="action-wrapper">
          <app-add-node (addedNode)="addChildNode($event)" [isTop]="false" [currentNode]="node"></app-add-node>
          <app-edit-node (edittedNode)="editNode($event)" [currentNode]="node"></app-edit-node>
          <app-delete-node (deletedNode)="deleteNode($event)" [currentNode]="node"></app-delete-node>
        </div>
      </li>
    </mat-tree-node>
    <!-- With Children -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
      <li >
        <!--                <pre>{{node | json}}</pre>-->
        <div class="mat-tree-node" (click)="onNodeSelected(node)" [ngStyle]="{'color': clickSelection.isSelected(node) ? markTreeSelection : null}">
          <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.Name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          {{node.Name}}
          <div class="action-wrapper">
            <app-add-node (addedNode)="addChildNode($event)" [isTop]="false" [currentNode]="node"></app-add-node>
            <app-edit-node (edittedNode)="editNode($event)" [currentNode]="node"></app-edit-node>
            <app-delete-node (deletedNode)="deleteNode($event)" [currentNode]="node"></app-delete-node>
          </div>
        </div>
        <ul [class.tree-wrapper-invisible]="!nestedTreeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>
}
@if (!createMode) {
  <div>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding [style.display]="filterLeafNode(node) ? 'none' : 'flex'">
        <button mat-icon-button disabled class="mini-button"></button>
        <mat-checkbox class="checklist-leaf-node"
          [checked]="checklistSelection.isSelected(node)"
        (change)="toggleNode(node)">{{node.item}}</mat-checkbox>
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
        <button mat-icon-button disabled class="mini-button"></button>
        <mat-form-field>
          <mat-label>New item...</mat-label>
          <input inputrestriction="basic1" matInput #itemValue placeholder="New item...">
        </mat-form-field>
        <button mat-button (click)="saveNode(node, itemValue.value)">Save</button>
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [style.display]="filterParentNode(node) ? 'none' : 'flex'">
        <button mat-icon-button matTreeNodeToggle class="mini-button"
          [attr.aria-label]="'toggle ' + node.filename">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <mat-checkbox [checked]="descendantsAllSelected(node)"
          [indeterminate]="descendantsPartiallySelected(node)"
        (change)="todoItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
      </mat-tree-node>
    </mat-tree>
  </div>
}


